import React from 'react'
import { NotAvailable } from '@myxplor/ui'

const NoAddress = () => <address>Address: <NotAvailable name="Address" /></address>

export const formatAddress = (props) => {

  if (!props) {
    return <NoAddress />
  }

  const { line_1, line_2, suburb, postcode, state } = props

  if (!line_1 && !line_2)
    return <NoAddress />

  return (
    <address>
      {[line_1, line_2].join(', ')} <br />
      {[suburb, postcode].join(', ')} <br />
      {state}
    </address>
  )
}

export const name = ({ name, first_name, last_name }) =>
  name ? name : [first_name, last_name].join(' ')



// WEBPACK FOOTER //
// ./src/parent-agreement/views/helpers.js